import { useTranslation } from "react-i18next";
import './landing-pv-section1.scss'

export const usePvSection1 = () => {
  const { t } = useTranslation();

  return { t };
};
